/* eslint-disable prefer-destructuring */
export default function handleRangedItems(data) {
  const objectOfRanged = {};
  let finalData = Object.fromEntries(
    Object.entries(data).filter((item) => {
      if (item[0].match(/_from|_to/)) {
        const splittedString = item[0].split("_");
        const endOfTheString = splittedString.pop();
        const string = splittedString.join("_");
        if (!objectOfRanged[string]) {
          objectOfRanged[string] = [];
        }
        if (endOfTheString === "from") {
          objectOfRanged[string][0] = item[1];
        }
        if (endOfTheString === "to") {
          objectOfRanged[string][1] = item[1];
        }
        return false;
      }
      return true;
    })
  );
  finalData = { ...finalData, ...objectOfRanged };
  return finalData;
}
